export default __webpack_public_path__ + "static/media/av7.f63ddf3d.jpg";